import styled from 'styled-components';

export const StyledButtonMenu = styled('div')`
  .button-menu {
    display: flex;
    align-items: center;
    padding: 3px;
    border-radius: 4px;
    background: var(--color-smoke-50);
  }

  .button-value.active {
    background: #fff;
    border-radius: 4px;
  }

  .button-value {
    border-radius: 4px;
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    padding: 2px 10px;
    cursor: pointer;
  }

  .button-menu.tabs {
    background: none;

    .button-value {
      background: #ffffff;
      border: 1px solid #f2f2f2;
      box-shadow: inset 0px 1px 2px rgba(18, 52, 77, 0.08);
      border-radius: 4px;
      padding: 10px 20px;
      display: flex;
      margin-right: 10px;
    }

    .button-value:hover {
      border-color: var(--color-smoke-300);
    }

    .button-value.active {
      background: #ffffff;
      border: 1px solid #12344d;
      box-shadow: inset 0px 1px 2px rgba(18, 52, 77, 0.08);
      border-radius: 4px;
    }

    .standard.button-value {
      span {
        border: none;
      }
      span:first-child {
        background: #fc0909;
        opacity: 0.56;
        height: 10px;
        width: 10px;
      }
      span:nth-child(2) {
        background: #d08239;
        opacity: 0.56;
        height: 10px;
        width: 10px;
      }
      span:nth-child(3) {
        background: #00a27b;
        opacity: 0.56;
        height: 11px;
        width: 11px;
      }
    }
  }

  .button-menu.tabs.scale {
    .button-value {
      padding: 10px 8px;
      span {
        border: transparent;
      }
    }
    .curved .btn-style.active {
      border-radius: 4px;
    }
    .square .btn-style.active {
      border-radius: 0;
    }
  }

  span.btn-style {
    display: block;
    width: 10px;
    height: 10px;
    margin-right: 5px;
    opacity: 0.2;
    border: 1px solid #12344d;
    border-radius: 50%;
  }

  .scale span.btn-style {
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
  }
  span.btn-style.active {
    color: #fff;
    background: #12344d;
    border-radius: 50%;
    opacity: 1;
  }
`;

export const StyledButtonCustomize = styled('div')`
  button:hover {
    background: var(--color-smoke-50) !important;
  }
`;

export const StyledScaleCustomize = styled('div')`
  width: 350px;
  background: #ffffff;
  box-shadow: 0px 2px 16px rgba(18, 52, 77, 0.16);
  border-radius: 4px;
  margin-top: 10px;

  [role='tablist'] {
    padding-top: 10px;
    box-shadow: 0px 2px 4px rgba(207, 215, 223, 0.3);
  }
  [role='tab'] {
    width: 50%;
    margin: 0 20px;
    text-align: center;
  }
  .block {
    display: block;
  }
  .mb-2 {
    margin-bottom: 16px;
  }
  .content {
    padding: 20px;

    .field {
      display: block;
      margin: 0 0 25px 0;

      &.inline {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        .end-max-length {
          display: none;
        }
      }

      .presets {
        text-align: end;
        color: var(--color-azure-800);
        font-size: 12px;
        margin-top: 5px;
        line-height: 1.4;
        position: absolute;
        right: 20px;
      }

      .half {
        width: 50%;
        width: 150px;
      }

      label {
        font-size: 13px;
        color: #183247;
        font-weight: 500;
        padding-left: 2px;
      }
    }
  }
`;
